{"linear":"0, 0, 1, 1","out":"0.26, 1, 0.48, 1","in-out":"0.34, 0, 0, 1"}